import styled from 'styled-components';

const ActionLabel = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.corporateRed};
  font-family: ${({ theme }) => theme.fonts.mainFont};
  line-height: 18px;
  ${props =>
    props.bold &&
    ` font-weight: 600;
`}
`;

export default ActionLabel;
